<form
  #f="ngForm"

  appFocusFirstElement
  [appCheckInputNumber]="[
    '',
    '',
    'accountNumber',
    'certificateNo',
    'representativeCertificateNo'
  ]"
  [appCheckPhone]="['phone', 'fax']"
>
  <mat-card>
    <mat-card-header>
      <mat-card-title
        >{{ "title.update_user" | translate }} {{ oldCustomerName }}
        <small class="form-text text-gray pull-left pb-2 float-right"
          >(<span style="color: red">*</span>)
          {{ "form.info" | translate }}</small
        >
      </mat-card-title>
    </mat-card-header>
    <mat-tab-group #myTabGroup (selectedIndexChange)="isInforTab = $event">
      <mat-tab [label]="'title.customer_detail_upper' | translate">

      </mat-tab>
      <mat-tab *ngIf="userType == 1 || (userType == 2 && checkDisplayConfigCustomer())"
        [label]="'title.config_group_customer' | translate">
        <app-customer-configuration (originGroupCustomerIds)="originGroupCustomerIds($event)"
        (onChangeGroupCustomerIds)="onChangeGroupCustomerIds($event)"
        [customerId]="customer.id"></app-customer-configuration>
      </mat-tab>
    </mat-tab-group>

    <mat-card-content [ngClass]="isInforTab === 0 ? '' : 'd-none'">
      <mat-accordion #accordion="matAccordion" [multi]="true">
        <!-- Thông tin khách hàng -->
        <mat-expansion-panel expanded="true">
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title">
              {{'title.customer_info' | translate}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row">
            <!-- tên đăng nhập -->
            <div class="col-md-4" *ngIf="!isNotAttestedUser">
              <small>{{ "form.username" | translate }}</small>
              <p class="dotted">{{ customer.adminUser }}</p>
            </div>

            <!-- primary email -->
            <div class="col-md-4" *ngIf="!isNotAttestedUser">
              <small>{{ "form.infomation_email" | translate }}</small>
              <p class="dotted">{{ customer.primaryEmail }}</p>
            </div>

            <!--loại khách hàng-->
            <div class="col-md-4">
              <mat-form-field class="w-100">
                <mat-label>{{ "form.customer_type" | translate }}</mat-label>
                <mat-select
                  #enterpriseTypeSelect
                  (focusout)="checkFocus = true"
                  (focusout)="checkFocus = true"
                  (focus)="
                    commonService.openComboBox(checkFocus, enterpriseTypeSelect)
                  "
                  id="focusSelect"
                  name="customerType"
                  [(ngModel)]="customer.customerType"
                  #customerType="ngModel"
                  [ngClass]="{
                    'is-invalid': f.submitted && customerType.invalid
                  }"
                  required
                  (selectionChange)="checkFocus = false; onChangeType()"
                >
                  <mat-option>
                    <ngx-mat-select-search
                      [noEntriesFoundLabel]="
                        'autocomplete.suggestion' | translate
                      "
                      [placeholderLabel]="'search_form.search' | translate"
                      [formControl]="enterpriseTypeFilterCtrl"
                    >
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option
                    *ngFor="let enterpirse of filteredEnterpriseType | async"
                    [value]="enterpirse.id"
                    (click)="
                      this.commonService.closeDropdownList(
                        this.enterpriseTypeSelect
                      )
                    "
                    title="{{ getEnterpriseTypeOptions(enterpirse.langs) }}"
                  >
                    {{ getEnterpriseTypeOptions(enterpirse.langs) }}
                  </mat-option>
                </mat-select>
                <mat-error
                  *ngIf="
                    f.submitted &&
                    customerType.invalid &&
                    customerType?.errors?.required
                  "
                >
                  {{ "validation.customer_type" | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <!--khách hàng-->
            <div
              class="{{
                customer.customerType == personalId ? 'col-md-4' : 'col-md-8'
              }}"
            >
              <mat-form-field class="w-100">
                <input
                  (focusout)="customer.name = customer.name.trim()"
                  matInput
                  autocomplete="off"
                  type="text"
                  name="name"
                  [(ngModel)]="customer.name"
                  #name="ngModel"
                  [ngClass]="{ 'is-invalid': f.submitted && name.invalid }"
                  required
                  maxlength="200"
                  [placeholder]="'headertable.customer_name' | translate"
                />
                <button
                  mat-button
                  *ngIf="customer.name"
                  type="button"
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="customer.name = ''"
                >
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error
                  *ngIf="f.submitted || name.invalid || name?.errors?.required"
                >
                  {{ "validation.customer_name" | translate }}
                </mat-error>
              </mat-form-field>
            </div>

<!--        Mã khách hàng-->
            <div class="col-md-4">
              <mat-form-field class="w-100">
                <mat-label>{{'headertable.customer_code' | translate}}</mat-label>
                <input matInput (focusout)="customer.customerCode = customer.customerCode.trim()"
                       autocomplete="off" type="text" name="customerCode" pattern="^\S+$"
                       [(ngModel)]="customer.customerCode" id="customerCode" #customerCode="ngModel" maxlength="50"/>
                <button mat-button *ngIf="customer.customerCode" type="button" matSuffix mat-icon-button aria-label="Clear"
                        (click)="customer.customerCode=''">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="customerCode?.errors?.pattern">
                  {{'headertable.error_customerCode' | translate}}
                </mat-error>
                <mat-error *ngIf="customerCode?.errors?.duplicate">
                  {{'headertable.error_customerCodeExist'|translate}}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- ngày sinh -->
            <div
              class="col-md-4"
              *ngIf="
                customer.customerType == personalId ||
                customer.customerType == null
              "
            >
              <mat-form-field class="w-100">
                <input
                  matInput
                  autocomplete="off"
                  [matDatepicker]="birthday4"
                  (change)="
                    this.commonService.resetDatePicker(
                      pickerInput2.value,
                      this.ngForm.controls['birthday']
                    )
                  "
                  name="birthday"
                  [(ngModel)]="customer.birthday"
                  (dateInput)="addEvent($event)"
                  (dateChange)="addEvent($event)"
                  maxlength="10"
                  #birthdayM="ngModel"
                  #pickerInput2
                  [max]="maxDate"
                  [placeholder]="'form.birthday' | translate"
                />
                <mat-datepicker-toggle matSuffix [for]="birthday4">
                  <i
                    matDatepickerToggleIcon
                    class="fa fa-calendar"
                    aria-hidden="true"
                    [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"
                  ></i>
                </mat-datepicker-toggle>
                <mat-datepicker #birthday4></mat-datepicker>
                <mat-error *ngIf="f.submitted || birthdayM.invalid">
                  {{ getErrorDateMessage(pickerInput2.value) }}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- giới tính -->
            <!-- <div class="col-md-4" *ngIf="customer.customerType == personalId || customer.customerType == null">
              <mat-form-field class="w-100">
                <mat-label>{{'form.sex' | translate}}</mat-label>
                <mat-select #sexSelect1 (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
                  (focus)="commonService.openComboBox(checkFocus, sexSelect1)" id="sex" name="sex"
                  [(ngModel)]="customer.sex">
                  <mat-option [value]="true" (click)="this.commonService.closeDropdownList(this.sexSelect1)">
                    {{'form.male' | translate}}</mat-option>
                  <mat-option [value]="false" (click)="this.commonService.closeDropdownList(this.sexSelect1)">
                    {{'form.female' | translate}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div> -->
            <div
              class="col-md-4"
              *ngIf="
                customer.customerType == personalId ||
                customer.customerType == null
              "
            >
              <mat-label style="color: #858796">{{
                "form.sex" | translate
              }}</mat-label
              ><br />
              <mat-radio-group
                #sexSelect1
                id="sex"
                name="sex"
                [(ngModel)]="customer.sex"
              >
                <mat-radio-button [value]="true" class="pt-2 mr-3">{{
                  "form.male" | translate
                }}</mat-radio-button>
                <mat-radio-button [value]="false">{{
                  "form.female" | translate
                }}</mat-radio-button>
              </mat-radio-group>
            </div>

            <!--mã số thuế-->
            <div
              class="col-md-4"
              *ngIf="
                customer.customerType != personalId &&
                customer.customerType != null
              "
            >
              <mat-form-field class="w-100">
                <input
                  (focusout)="customer.taxCode = customer.taxCode.trim()"
                  matInput
                  autocomplete="off"
                  type="text"
                  name="taxCode"
                  [(ngModel)]="customer.taxCode"
                  #taxCode="ngModel"
                  [ngClass]="{ 'is-invalid': f.submitted && taxCode.invalid }"
                  [maxlength]="taxCodeMaxlength"
                  [placeholder]="'form.tax_code' | translate"
                  id="taxCode"
                  [disabled]="isDisableMST"
                  required maxlength="20"
                />
                <button
                  mat-button
                  *ngIf="customer.taxCode"
                  type="button"
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="customer.taxCode = ''"
                  [disabled]="isDisableMST"
                >
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error
                  *ngIf="
                    f.submitted && taxCode.invalid && taxCode?.errors?.validIp
                  "
                >
                  {{ "validation.tax_code_number" | translate }}
                </mat-error>
                <mat-error *ngIf="taxCode?.errors?.duplicate">
                  {{ "validation.err_cust_tax_code_duplicate" | translate }}
                </mat-error>
                <mat-error *ngIf="f.submitted || taxCode?.errors?.required">
                         {{'validation.code_tax_request' | translate}}
                      </mat-error>
              </mat-form-field>
            </div>

            <!--loại giấy tờ-->
            <div class="col-md-4">
              <mat-form-field class="w-100">
                <mat-label>
                  {{
                    "update_enterprise.representative_info.cbx_type_certification.lbl_type_certification"
                      | translate
                  }}
                </mat-label>
                <mat-select
                  #certificationTypeSelect
                  (focusout)="checkFocus = true"
                  (selectionChange)="checkFocus = false"
                  (focus)="
                    commonService.openComboBox(
                      checkFocus,
                      certificationTypeSelect
                    )
                  "
                  id="certificateId"
                  name="certificateId"
                  [(ngModel)]="customer.certificateId"
                  #certificateId="ngModel"
                  [ngClass]="{
                    'is-invalid': f.submitted && certificateId.invalid
                  }"
                  required
                  [disabled]="isDisableLGT"
                >
                  <mat-option>
                    <ngx-mat-select-search
                      [noEntriesFoundLabel]="
                        'autocomplete.suggestion' | translate
                      "
                      [placeholderLabel]="'search_form.search' | translate"
                      [formControl]="
                        customer.customerType == personalId
                          ? representativeCertificateTypeFilterCtrl
                          : certificationTypeFilterCtrl
                      "
                    >
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option
                    *ngFor="
                      let certificate of (customer.customerType == personalId
                        ? filteredRepresentativeCertificateType
                        : filteredCertificationType
                      ) | async
                    "
                    [value]="certificate.id"
                    (click)="
                      this.commonService.closeDropdownList(
                        this.certificationTypeSelect
                      )
                    "
                  >
                    {{ getEnterpriseTypeOptions(certificate.langs) }}
                  </mat-option>
                </mat-select>
                <mat-error
                  *ngIf="
                    f.submitted ||
                    certificateId.invalid ||
                    certificateId?.errors?.required
                  "
                >
                  {{ "validation.type_of_doc" | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <!--số giấy tờ của loại KH là Cá nhân-->
            <div class="col-md-4" *ngIf="customer.customerType == personalId">
              <mat-form-field class="w-100">
                <input
                  matInput
                  [pattern]="certificateNoPattern"
                  autocomplete="off"
                  type="text"
                  name="certificateNo1"
                  (focusout)="
                    customer.certificateNo = customer.certificateNo.trim()
                  "
                  [(ngModel)]="customer.certificateNo"
                  #certificateNo1="ngModel"
                  [ngClass]="{
                    'is-invalid': f.submitted && certificateNo1.invalid
                  }"
                  required
                  maxlength="20"
                  [placeholder]="'form.certification_no' | translate"
                  id="certificateNo1"
                  disabled
                />
                <button
                  mat-button
                  *ngIf="customer.certificateNo"
                  type="button"
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="customer.certificateNo = ''"
                  disabled
                >
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="certificateNo1?.errors?.required">
                  {{ "validation.number_of_doc" | translate }}
                </mat-error>
                <mat-error *ngIf="certificateNo1?.errors?.pattern">
                  {{ "validation.gpkd_format" | translate }}
                </mat-error>
                <mat-error *ngIf="certificateNo1?.errors?.duplicate">
                  {{
                    "validation.err_cust_certificate_no_duplicate" | translate
                  }}
                </mat-error>
              </mat-form-field>
            </div>

            <!--số giấy tờ của loại KH là Công ty, Cơ quan-->
            <div class="col-md-4" *ngIf="customer.customerType != personalId">
              <mat-form-field class="w-100">
                <input
                  (focusout)="
                    customer.certificateNo = customer.certificateNo.trim()
                  "
                  matInput
                  autocomplete="off"
                  type="text"
                  name="certificateNo"
                  [(ngModel)]="customer.certificateNo"
                  [placeholder]="'form.certification_no' | translate"
                  #certificateNo="ngModel"
                  [ngClass]="{
                    'is-invalid': f.submitted && certificateNo.invalid
                  }"
                  required
                  maxlength="20"
                  appCheckSpace
                  id="certificateNo"
                  disabled
                />
                <button
                  mat-button
                  *ngIf="customer.certificateNo"
                  type="button"
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="customer.certificateNo = ''"
                  disabled
                >
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="certificateNo?.errors?.required">
                  {{ "validation.number_of_doc" | translate }}
                </mat-error>
                <mat-error *ngIf="certificateNo?.errors?.validInput">
                  {{ "validation.gpkd_format" | translate }}
                </mat-error>
                <mat-error *ngIf="certificateNo?.errors?.duplicate">
                  {{
                    "validation.err_cust_certificate_no_duplicate" | translate
                  }}
                </mat-error>
              </mat-form-field>
            </div>

            <!--ngày cấp-->
            <div class="col-md-4">
              <mat-form-field class="w-100">
                <input
                  matInput
                  autocomplete="off"
                  [max]="maxDate"
                  (dateInput)="addEvent($event)"
                  (dateChange)="addEvent($event)"
                  [matDatepicker]="issuedDate1"
                  name="issuedDate"
                  [(ngModel)]="customer.issuedDate"
                  #issuedDate="ngModel"
                  [ngClass]="{
                    'is-invalid': f.submitted && issuedDate.invalid
                  }"
                  required
                  maxlength="10"
                  #pickerInput3
                  [placeholder]="'form.issued_date' | translate"
                />
                <mat-datepicker-toggle matSuffix [for]="issuedDate1">
                  <i
                    matDatepickerToggleIcon
                    class="fa fa-calendar"
                    aria-hidden="true"
                    [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"
                  ></i>
                </mat-datepicker-toggle>
                <mat-datepicker #issuedDate1></mat-datepicker>
                <mat-error *ngIf="f.submitted || issuedDate.invalid">
                  <span class="text-error" *ngIf="issuedDate.invalid">
                    {{ getErrorDateMessage(pickerInput3.value) }}
                  </span>
                  <span
                    class="text-error"
                    *ngIf="getErrorDateMessage(pickerInput3.value) == null"
                  >
                    {{ "validation.issued_date" | translate }}
                  </span>
                </mat-error>
              </mat-form-field>
            </div>

            <!-- nơi cấp -->
            <div class="col-md-8">
              <mat-form-field class="w-100">
                <input
                  (focusout)="customer.issuedAt = customer.issuedAt.trim()"
                  matInput
                  autocomplete="off"
                  type="text"
                  name="issuedAt"
                  [(ngModel)]="customer.issuedAt"
                  #issuedAt="ngModel"
                  [ngClass]="{ 'is-invalid': f.submitted && issuedAt.invalid }"
                  required
                  maxlength="100"
                  [placeholder]="'form.issued_by' | translate"
                />
                <button
                  mat-button
                  *ngIf="customer.issuedAt"
                  type="button"
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="customer.issuedAt = ''"
                >
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error
                  *ngIf="
                    f.submitted ||
                    issuedAt.invalid ||
                    issuedAt?.errors?.required
                  "
                >
                  {{ "validation.issued_by" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </mat-expansion-panel>

        <!-- Phần chưa cập nhật => Thông tin người đại diện -->
        <mat-expansion-panel

          *ngIf="
          customer.customerType != personalId && customer.customerType != null
          "
        >
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title">
              {{ "title.representative_info" | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row">
            <!-- họ tên -->
            <div class="col-md-4">
              <mat-form-field class="w-100">
                <input
                  (focusout)="
                    customer.representative = customer.representative.trim()
                  "
                  matInput
                  autocomplete="off"
                  type="text"
                  name="representative"
                  [(ngModel)]="customer.representative"
                  #representative="ngModel"
                  [ngClass]="{
                    'is-invalid': f.submitted && representative.invalid
                  }"
                  required
                  maxlength="200"
                  [placeholder]="'form.full_name' | translate"
                />
                <button
                  mat-button
                  *ngIf="customer.representative"
                  type="button"
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="customer.representative = ''"
                >
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error
                  *ngIf="
                    f.submitted &&
                    representative.invalid &&
                    representative?.errors?.required
                  "
                >
                  {{ "validation.representative" | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- chức vụ -->
            <div class="col-md-4">
              <mat-form-field class="w-100">
                <input
                  (focusout)="customer.position = customer.position.trim()"
                  matInput
                  autocomplete="off"
                  type="text"
                  name="position"
                  [(ngModel)]="customer.position"
                  #position="ngModel"
                  [ngClass]="{ 'is-invalid': f.submitted && position.invalid }"
                  required
                  maxlength="200"
                  [placeholder]="'form.position' | translate"
                />
                <button
                  mat-button
                  *ngIf="customer.position"
                  type="button"
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="customer.position = ''"
                >
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error
                  *ngIf="
                    f.submitted &&
                    position.invalid &&
                    position?.errors?.required
                  "
                >
                  {{ "validation.position" | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- giới tính -->
            <!-- <div class="col-md-4">
              <mat-form-field class="w-100">
                <mat-label>{{'form.sex' | translate}}</mat-label>
                <mat-select #sexSelect2 (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
                  (focus)="commonService.openComboBox(checkFocus, sexSelect2)" id="sex" name="sex"
                  [(ngModel)]="customer.sex">
                  <mat-option [value]="true" (click)="this.commonService.closeDropdownList(this.sexSelect2)">
                    {{'form.male' | translate}}</mat-option>
                  <mat-option [value]="false" (click)="this.commonService.closeDropdownList(this.sexSelect2)">
                    {{'form.female' | translate}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div> -->
            <div class="col-md-4">
              <mat-label style="color: #858796">{{
                "form.sex" | translate
              }}</mat-label
              ><br />
              <mat-radio-group
                #sexSelect2
                id="sex"
                name="sex"
                [(ngModel)]="customer.sex"
              >
                <mat-radio-button [value]="true" class="pt-2 mr-3">{{
                  "form.male" | translate
                }}</mat-radio-button>
                <mat-radio-button [value]="false">{{
                  "form.female" | translate
                }}</mat-radio-button>
              </mat-radio-group>
            </div>
          </div>

          <div class="row">
            <!-- ngày sinh -->
            <div class="col-md-4">
              <mat-form-field class="w-100">
                <input
                  matInput
                  autocomplete="off"
                  [max]="maxDate"
                  [matDatepicker]="birthday1"
                  (dateInput)="addEvent($event)"
                  (dateChange)="addEvent($event)"
                  name="birthday1"
                  (change)="
                    this.commonService.resetDatePicker(
                      pickerInput.value,
                      this.ngForm.controls['birthday1']
                    )
                  "
                  [(ngModel)]="customer.birthday"
                  maxlength="10"
                  #birthday2="ngModel"
                  #pickerInput
                  [placeholder]="'form.birthday' | translate"
                />
                <mat-datepicker-toggle matSuffix [for]="birthday1">
                  <i
                    matDatepickerToggleIcon
                    class="fa fa-calendar"
                    aria-hidden="true"
                    [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"
                  ></i>
                </mat-datepicker-toggle>
                <mat-datepicker #birthday1></mat-datepicker>
                <mat-error *ngIf="f.submitted || birthday2.invalid">
                  {{ getErrorDateMessage(pickerInput.value) }}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- loại giấy tờ -->
            <div class="col-md-4">
              <mat-form-field class="w-100">
                <mat-label>{{
                  "form.type_certification" | translate
                }}</mat-label>
                <mat-select
                  #representativeCertificateSelect
                  (focusout)="checkFocus = true"
                  (selectionChange)="checkFocus = false"
                  (focus)="
                    commonService.openComboBox(
                      checkFocus,
                      representativeCertificateSelect
                    )
                  "
                  id="representativeCertificateId"
                  name="representativeCertificateId"
                  [(ngModel)]="customer.representativeCertificateId"
                >
                  <mat-option>
                    <ngx-mat-select-search
                      [noEntriesFoundLabel]="
                        'autocomplete.suggestion' | translate
                      "
                      [placeholderLabel]="'search_form.search' | translate"
                      [formControl]="representativeCertificateTypeFilterCtrl"
                    >
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option
                    *ngFor="
                      let representativeCertificateType of filteredRepresentativeCertificateType
                        | async
                    "
                    [value]="representativeCertificateType.id"
                    (click)="
                      this.commonService.closeDropdownList(
                        this.representativeCertificateSelect
                      )
                    "
                  >
                    {{
                      getEnterpriseTypeOptions(
                        representativeCertificateType.langs
                      )
                    }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- số giấy tờ -->
            <div class="col-md-4">
              <mat-form-field class="w-100">
                <input
                  (focusout)="
                    customer.representativeCertificateNo =
                      customer.representativeCertificateNo.trim()
                  "
                  matInput
                  autocomplete="off"
                  type="text"
                  name="representativeCertificateNo"
                  [(ngModel)]="customer.representativeCertificateNo"
                  #representativeCertificateNo="ngModel"
                  maxlength="20"
                  [placeholder]="'form.certification_no' | translate"
                />
                <button
                  mat-button
                  *ngIf="customer.representativeCertificateNo"
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="customer.representativeCertificateNo = ''"
                >
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error
                  *ngIf="f.submitted || representativeCertificateNo.invalid"
                >
                  {{ "validation.gpkd_format" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <!-- ngày cấp -->
            <div class="col-md-4">
              <mat-form-field class="w-100">
                <input
                  matInput
                  autocomplete="off"
                  [max]="maxDate"
                  (change)="
                    this.commonService.resetDatePicker(
                      pickerInput5.value,
                      this.ngForm.controls['representativeIssuedDate']
                    )
                  "
                  [matDatepicker]="representativeIssuedDate1"
                  name="representativeIssuedDate"
                  [(ngModel)]="customer.representativeIssuedDate"
                  #birthday5="ngModel"
                  maxlength="10"
                  (dateInput)="addEvent($event)"
                  (dateChange)="addEvent($event)"
                  #pickerInput5
                  [placeholder]="'form.issued_date' | translate"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="representativeIssuedDate1"
                >
                  <i
                    matDatepickerToggleIcon
                    class="fa fa-calendar"
                    aria-hidden="true"
                    [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"
                  ></i>
                </mat-datepicker-toggle>
                <mat-datepicker #representativeIssuedDate1></mat-datepicker>
                <mat-error *ngIf="f.submitted || birthday5.invalid">
                  {{ getErrorDateMessage(pickerInput5.value) }}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- nơi cấp -->
            <div class="col-md-4">
              <mat-form-field class="w-100">
                <input
                  (focusout)="
                    customer.representativeIssuedAt =
                      customer.representativeIssuedAt.trim()
                  "
                  matInput
                  autocomplete="off"
                  type="text"
                  name="representativeIssuedAt"
                  [(ngModel)]="customer.representativeIssuedAt"
                  maxlength="200"
                  [placeholder]="'form.issued_by' | translate"
                />
                <button
                  mat-button
                  *ngIf="customer.representativeIssuedAt"
                  type="button"
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="customer.representativeIssuedAt = ''"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
          </div>
        </mat-expansion-panel>

        <!-- Thông tin liên hệ -->
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title">
              {{ "title.contact_info" | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row font-weight-bold">
            <div class="col-12">
              <div class="d-flex align-items-center">
                <div style="font-size: 15px; color:#000000DE" class="">{{'form.use_new_area' | translate}}</div>
                <div class="d-flex pl-2">
                  <div (click)="changeAddress(true)"
                    [ngClass]="customer.isNewAddress ? 'status-document' : 'text-off-document'"
                    style="cursor: pointer; border-right: none; font-weight: 600; border: 1px solid #D9D9D9; padding: 2px 10px; border-bottom-left-radius: 3px; border-top-left-radius: 3px;">
                    {{'user_group.on_document' | translate}}</div>
                  <div (click)="changeAddress(false)"
                    [ngClass]="!customer.isNewAddress ? 'status-document' : 'text-off-document'"
                    style="cursor: pointer; border-left: none; font-weight: 600; border: 1px solid #D9D9D9; padding: 2px 10px; border-bottom-right-radius: 3px; border-top-right-radius: 3px;">
                    {{'user_group.off_document' | translate}}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <!-- điện thoại -->
            <div class="col-md-4">
              <mat-form-field class="w-100">
                <input
                  (focusout)="customer.phone = customer.phone.trim()"
                  matInput
                  autocomplete="off"
                  type="text"
                  name="phoneNumber"
                  [(ngModel)]="customer.phone"
                  #phoneNumber="ngModel"
                  [ngClass]="{ 'is-invalid': f.submitted && phoneNumber.invalid }"
                  required
                  [maxlength]="maxLengthPhone"
                  [placeholder]="'search_form.phone' | translate"
                  [pattern]="phonePattern2"
                />
                <button
                  mat-button
                  *ngIf="customer.phone"
                  type="button"
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="customer.phone = ''"
                >
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="f.submitted || phoneNumber.invalid">
                  <span *ngIf="phoneNumber?.errors?.required" class="text-error">{{
                    "validation.phone" | translate
                  }}</span>
                  <span *ngIf="phoneNumber?.errors?.pattern" class="text-error">{{
                    "validation.phone_format_upgrade" | translate
                  }}</span>
                </mat-error>
              </mat-form-field>
            </div>

            <!-- email -->
            <div class="col-md-4">
              <mat-form-field class="w-100">
                <mat-label>{{ "form.receive_email" | translate }}</mat-label>
                <input
                  (focusout)="customer.email = customer.email.trim()"
                  matInput
                  autocomplete="off"
                  type="text"
                  name="email"
                  [(ngModel)]="customer.email"
                  #email="ngModel"
                  [required]="scopeType == 1"
                  [maxlength]="emailMaxlength"
                  [pattern]="emailPattern"
                  [placeholder]="'placeholder.email' | translate"
                />
                <button
                  mat-button
                  *ngIf="customer.email"
                  type="button"
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="customer.email = ''"
                >
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="f.submitted || email.invalid">
                  <span class="text-error" *ngIf="email?.errors?.required && scopeType == 1">
                    {{ "validation.email" | translate }}
                  </span>
                  <span class="text-error" *ngIf="email?.errors?.pattern">
                    {{ "validation.email_format" | translate }}
                  </span>
                </mat-error>
              </mat-form-field>
            </div>

            <!-- fax -->
            <div class="col-md-4">
              <mat-form-field class="w-100">
                <input
                  (focusout)="customer.fax = customer.fax.trim()"
                  matInput
                  autocomplete="off"
                  type="text"
                  name="fax"
                  [(ngModel)]="customer.fax"
                  #fax="ngModel"
                  [ngClass]="{ 'is-invalid': f.submitted && fax.invalid }"
                  maxlength="20"
                  [placeholder]="'form.fax' | translate"
                />
                <button
                  mat-button
                  *ngIf="customer.fax"
                  type="button"
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="customer.fax = ''"
                >
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error
                  *ngIf="
                    f.submitted || (fax.invalid && fax?.errors?.validInput)
                  "
                >
                  {{ "validation.fax_format" | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- tỉnh/Thành phố -->
            <div class="col-md-4">
              <mat-form-field class="w-100">
                <mat-label>{{ "form.city" | translate }}</mat-label>
                <mat-select
                  #citySelect
                  (focusout)="checkFocus = true"
                  (focus)="commonService.openComboBox(checkFocus, citySelect)"
                  id="cityId"
                  name="cityId"
                  (selectionChange)="checkFocus = false; onChange($event.value, customer.isNewAddress ? 2: 1)"
                  [(ngModel)]="customer.cityId"
                  #cityId="ngModel"
                  [ngClass]="{ 'is-invalid': f.submitted && cityId.invalid }"
                  required
                  maxlength="100"
                >
                  <mat-option>
                    <ngx-mat-select-search
                      [noEntriesFoundLabel]="
                        'autocomplete.suggestion' | translate
                      "
                      [placeholderLabel]="'search_form.search' | translate"
                      [formControl]="cityFilterCtrl"
                    >
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option [value]="null" mat-selected>{{
                    "form.select_address" | translate
                  }}</mat-option>
                  <mat-option
                    *ngFor="let city of filteredCity | async"
                    [value]="city.id"
                    (click)="
                      this.commonService.closeDropdownList(this.citySelect)
                    "
                  >
                    {{ city.name }}
                  </mat-option>
                </mat-select>
                <mat-error
                  *ngIf="
                    f.submitted || cityId.invalid || cityId?.errors?.required
                  "
                >
                  {{ "validation.city" | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- quận/Huyện -->
            <div class="col-md-4" *ngIf="!customer.isNewAddress">
              <mat-form-field class="w-100">
                <mat-label>{{ "form.district" | translate }}</mat-label>
                <mat-select
                  #districtSelect
                  (focusout)="checkFocus = true"
                  (focus)="
                    commonService.openComboBox(checkFocus, districtSelect)
                  "
                  id="districtId"
                  name="districtId"
                  (selectionChange)="
                    checkFocus = false; onChange($event.value, 2)
                  "
                  [(ngModel)]="customer.districtId"
                  #districtId="ngModel"
                  maxlength="100"
                >
                  <mat-option>
                    <ngx-mat-select-search
                      [noEntriesFoundLabel]="
                        'autocomplete.suggestion' | translate
                      "
                      [placeholderLabel]="'search_form.search' | translate"
                      [formControl]="districtsFilterCtrl"
                    >
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option [value]="null" mat-selected>{{
                    "form.select_address" | translate
                  }}</mat-option>
                  <mat-option
                    *ngFor="let district of filteredDistricts | async"
                    [value]="district.id"
                    (click)="
                      this.commonService.closeDropdownList(this.districtSelect)
                    "
                  >
                    {{ district.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- phường/Xã -->
            <div class="col-md-4">
              <ng-container *ngIf="notHasWard; else hasWard">
                <mat-form-field class="w-100">
                  <mat-label>{{ "form.ward" | translate }}</mat-label>
                  <mat-select
                    (focusout)="checkFocus = true"
                    (selectionChange)="checkFocus = false"
                    #wardSelect1
                    (focus)="
                      commonService.openComboBox(checkFocus, wardSelect1)
                    "
                    id="wardId"
                    name="wardId"
                    [(ngModel)]="customer.wardId"
                    #wardId="ngModel"
                  >
                    <mat-option>
                      <ngx-mat-select-search
                        [noEntriesFoundLabel]="
                          'autocomplete.suggestion' | translate
                        "
                        [placeholderLabel]="'search_form.search' | translate"
                        [formControl]="wardFilterCtrl"
                      >
                      </ngx-mat-select-search>
                    </mat-option>
                    <mat-option [value]="null" mat-selected>{{
                      "form.select_address" | translate
                    }}</mat-option>
                    <mat-option
                      *ngFor="let ward of filteredWard | async"
                      [value]="ward.id"
                      maxlength="100"
                    >
                      {{ ward.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </ng-container>
              <ng-template #hasWard>
                <mat-form-field class="w-100">
                  <mat-label>{{ "form.ward" | translate }}</mat-label>
                  <mat-select
                    #wardSelect
                    (focusout)="checkFocus = true"
                    (selectionChange)="checkFocus = false"
                    (focus)="commonService.openComboBox(checkFocus, wardSelect)"
                    id="wardId"
                    name="wardId"
                    [(ngModel)]="customer.wardId"
                    #wardId="ngModel"
                  >
                    <mat-option>
                      <ngx-mat-select-search
                        [noEntriesFoundLabel]="
                          'autocomplete.suggestion' | translate
                        "
                        [placeholderLabel]="'search_form.search' | translate"
                        [formControl]="wardFilterCtrl"
                      >
                      </ngx-mat-select-search>
                    </mat-option>
                    <mat-option [value]="null" mat-selected>{{
                      "form.select_address" | translate
                    }}</mat-option>
                    <mat-option
                      *ngFor="let ward of filteredWard | async"
                      [value]="ward.id"
                      maxlength="100"
                      (click)="
                        this.commonService.closeDropdownList(this.wardSelect)
                      "
                    >
                      {{ ward.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </ng-template>
            </div>
          </div>

          <div class="row">
            <!-- địa chỉ -->
            <div class="col-md-8">
              <mat-form-field class="w-100">
                <input
                  (focusout)="customer.address = customer.address.trim()"
                  matInput
                  autocomplete="off"
                  type="text"
                  name="address"
                  [(ngModel)]="customer.address"
                  #address="ngModel"
                  [ngClass]="{ 'is-invalid': f.submitted && address.invalid }"
                  required
                  maxlength="200"
                  [placeholder]="'headertable.address' | translate"
                />
                <button
                  mat-button
                  *ngIf="customer.address"
                  type="button"
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="customer.address = ''"
                >
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error
                  *ngIf="
                    f.submitted || address.invalid || address?.errors?.required
                  "
                >
                  {{ "validation.address" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </mat-expansion-panel>

        <!-- Thông tin thanh toán -->
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title">
              {{ "title.pay_info" | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row">
            <!-- số tài khoản -->
            <div class="col-md-6">
              <mat-form-field class="w-100">
                <input
                  (focusout)="
                    customer.accountNumber = customer.accountNumber.trim()
                  "
                  matInput
                  autocomplete="off"
                  type="text"
                  name="accountNumber"
                  [(ngModel)]="customer.accountNumber"
                  #accountNumber="ngModel"
                  [maxlength]="accountNumberMaxlength"
                  [placeholder]="'form.accnumber' | translate"
                />
                <button
                  mat-button
                  *ngIf="customer.accountNumber"
                  type="button"
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="customer.accountNumber = ''"
                >
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error
                  *ngIf="
                    f.submitted ||
                    accountNumber?.invalid ||
                    accountNumber?.errors?.validIp
                  "
                >
                  {{ "validation.account_number" | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Tên chủ tài khoản -->
            <div class="col-md-6">
              <mat-form-field class="w-100">
                <input
                  (focusout)="customer.accountName = customer.accountName.trim()"
                  matInput
                  autocomplete="off"
                  type="text"
                  name="accountName"
                  [(ngModel)]="customer.accountName"
                  [maxlength]="accountNameMaxlength"
                  [placeholder]="'form.accountName' | translate"
                />
                <button
                  mat-button
                  *ngIf="customer.accountName"
                  type="button"
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="customer.accountName = ''"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <!-- ngân hàng -->
            <div class="col-md-6">
              <!-- <mat-form-field class="w-100">
                <input
                  (focusout)="customer.bankName = customer.bankName.trim()"
                  matInput
                  autocomplete="off"
                  type="text"
                  name="bankName"
                  [(ngModel)]="customer.bankName"
                  [maxlength]="bankMaxlength"
                  [placeholder]="'form.bank' | translate"
                />
                <button
                  mat-button
                  *ngIf="customer.bankName"
                  type="button"
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="customer.bankName = ''"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field> -->
              <mat-form-field class="w-100">
                <mat-select #bankSelect (focusout)="(checkFocus = true)"
                  (focus)="commonService.openComboBox(checkFocus, bankSelect)" id="focusSelect" name="type"
                  (selectionChange)="checkFocus = false;"
                  [(ngModel)]="customer.bankName" #type="ngModel"
                  [placeholder]="'form.bank' | translate"
                >
                  <mat-option>
                    <ngx-mat-select-search [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                      [placeholderLabel]="'search_form.search' | translate" [formControl]="bankFilterCtrl">
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option [value]="null" mat-selected>{{'form.select_address' | translate}}</mat-option>
                  <mat-option *ngFor="let bankName of filteredBankName | async" [value]="bankName.key"
                    (click)="this.commonService.closeDropdownList(this.bankSelect)"
                    title="{{bankName.value}}">
                    {{bankName.value}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- chi nhánh -->
            <div class="col-md-6">
              <mat-form-field class="w-100">
                <input
                  (focusout)="customer.bankBranch = customer.bankBranch.trim()"
                  matInput
                  autocomplete="off"
                  type="text"
                  name="bankBranch"
                  [(ngModel)]="customer.bankBranch"
                  [maxlength]="bankMaxlength"
                  [placeholder]="'search_form.branch' | translate"
                />
                <button
                  mat-button
                  *ngIf="customer.bankBranch"
                  type="button"
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="customer.bankBranch = ''"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
          </div>
        </mat-expansion-panel>

        <!-- Tệp đính kèm -->
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title">
              {{ "title.attach" | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="pb-3">
            <app-upload-multi-file
              (hasChange)="onAttachmentChange($event)"
              [arrAttachments]="customer.attachments"
              [isCustomer]="true"
            ></app-upload-multi-file>
            <div class="text-center">
              <mat-hint class="hint-text">
                {{ "hint.attach_accept_pdf_image" | translate }}<br />
                {{ "hint.attach_accept_pdf_image_sub" | translate }}
              </mat-hint>
            </div>
          </div>
        </mat-expansion-panel>

         <!-- Hồ sơ khách hàng -->
        <mat-expansion-panel expanded="true">
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title">
              {{ customer.customerType == 10000 ? ('title.customer_information' | translate) : ('title.enterprise_information' | translate)}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <app-kyc-customer-infor [type]="customer.customerType == 10000 ? 'personal' : 'enterprise'" [listImageResponse]="dataImage" (imageUpload)="imageUpload($event)"></app-kyc-customer-infor>
        </mat-expansion-panel>
      </mat-accordion>
    </mat-card-content>

    <!-- Huỷ bỏ & Lưu  -->
    <mat-card-actions class="text-center">
      <button appTrackEvent="w.btn.danh_sach_kh.cap_nhat.huy_bo"
        mat-stroked-button
        color="primary"
        class="mr-3"
        (click)="onNoClick()"
        type="button"
      >
        <mat-icon class="mr-0">cancel</mat-icon>
        {{ "button.cancel" | translate }}
      </button>
      <button appTrackEvent="w.btn.danh_sach_kh.cap_nhat.luu"
        *ngIf="checkDisplayBtnUpdate()"
        mat-raised-button
        [disabled]="!isFormChanging"
        color="primary" type="button"
        (click)="
          !f.form.valid
          ? isInvalidForm()
          : 'true' && f.form.valid && onUpdateCustomer()"
       >
        <mat-icon class="mr-0">save</mat-icon>
        {{ "button.save" | translate }}
      </button>
    </mat-card-actions>
  </mat-card>
</form>
